__turbopack_context__.v({
  "articleBody": "BlogSecLeft-module__vff_qq__articleBody",
  "articleHtml": "BlogSecLeft-module__vff_qq__articleHtml",
  "blogSecLeft": "BlogSecLeft-module__vff_qq__blogSecLeft",
  "breadcrumbWrap": "BlogSecLeft-module__vff_qq__breadcrumbWrap",
  "bulletList": "BlogSecLeft-module__vff_qq__bulletList",
  "commentForm": "BlogSecLeft-module__vff_qq__commentForm",
  "commentInput": "BlogSecLeft-module__vff_qq__commentInput",
  "commentSection": "BlogSecLeft-module__vff_qq__commentSection",
  "commentTextarea": "BlogSecLeft-module__vff_qq__commentTextarea",
  "faqAnswer": "BlogSecLeft-module__vff_qq__faqAnswer",
  "faqItem": "BlogSecLeft-module__vff_qq__faqItem",
  "faqList": "BlogSecLeft-module__vff_qq__faqList",
  "faqOverride": "BlogSecLeft-module__vff_qq__faqOverride",
  "faqQuestion": "BlogSecLeft-module__vff_qq__faqQuestion",
  "faqSection": "BlogSecLeft-module__vff_qq__faqSection",
  "fieldError": "BlogSecLeft-module__vff_qq__fieldError",
  "formField": "BlogSecLeft-module__vff_qq__formField",
  "imageRow": "BlogSecLeft-module__vff_qq__imageRow",
  "infoText": "BlogSecLeft-module__vff_qq__infoText",
  "inputGroup": "BlogSecLeft-module__vff_qq__inputGroup",
  "inputGroupError": "BlogSecLeft-module__vff_qq__inputGroupError",
  "inputLegend": "BlogSecLeft-module__vff_qq__inputLegend",
  "inputRow": "BlogSecLeft-module__vff_qq__inputRow",
  "itemTitle": "BlogSecLeft-module__vff_qq__itemTitle",
  "mainHeading": "BlogSecLeft-module__vff_qq__mainHeading",
  "paragraph": "BlogSecLeft-module__vff_qq__paragraph",
  "sectionBlock": "BlogSecLeft-module__vff_qq__sectionBlock",
  "sectionTitle": "BlogSecLeft-module__vff_qq__sectionTitle",
  "subHeading": "BlogSecLeft-module__vff_qq__subHeading",
  "submitBtn": "BlogSecLeft-module__vff_qq__submitBtn",
});
